import React from 'react';
import { useSelector } from 'react-redux';
import { FaArrowRight, FaTools } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import ManpowerServices from '../../components/services/ManPower';
import ServicesRent from '../../components/services/ServicesRent';
import FaqSection from '../../components/about/FAQ';

const GeneralContracting = () => {
  const { language } = useSelector((state) => state.language);
  const navigate = useNavigate();

  const translations = {
    gb: {
      topData: {
        title: 'hello',
        subtitle: 'Service',
        description: 'yesssssss',
        buttonText: 'Get in Touch',
      },
      heroContent: {
        title: 'General Contracting',
        subtitle: 'Services',
        description: 'Get the right General Contracting for your job – on time, every time. Professional-grade machinery with flexible rental terms.',
        buttonText: 'Get in Touch',
      },
    },
    sa: {
      topData: {
        title: 'مرحباً',
        subtitle: 'الخدمة',
        description: 'نعم',
        buttonText: 'تواصل معنا',
      },
      heroContent: {
        title: 'المقاولات العامة',
        subtitle: 'الخدمات',
        description: 'احصل على المقاولات العامة المناسبة لعملك - في الوقت المحدد، في كل مرة. معدات احترافية مع شروط تأجير مرنة.',
        buttonText: 'تواصل معنا',
      },
    },
    fr: {
      topData: {
        title: 'Bonjour',
        subtitle: 'Service',
        description: 'Oui',
        buttonText: 'Contactez-nous',
      },
      heroContent: {
        title: 'Contracting Général',
        subtitle: 'Services',
        description: 'Obtenez le bon contracting général pour votre travail – à temps, à chaque fois. Machines de qualité professionnelle avec des conditions de location flexibles.',
        buttonText: 'Contactez-nous',
      },
    },
    de: {
      topData: {
        title: 'Hallo',
        subtitle: 'Dienstleistung',
        description: 'Ja',
        buttonText: 'Kontaktieren Sie uns',
      },
      heroContent: {
        title: 'Allgemeine Auftragsvergabe',
        subtitle: 'Dienstleistungen',
        description: 'Holen Sie sich die richtige allgemeine Auftragsvergabe für Ihren Job – pünktlich, jedes Mal. Professionelle Maschinen mit flexiblen Mietbedingungen.',
        buttonText: 'Kontaktieren Sie uns',
      },
    },
  };

  const t = translations[language] || translations.gb;

  return (
    <>
      <section
        className="equipment-rental-hero"
        style={{ background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)' }}
      >
        <div className="container h-100 px-3">
          <div className="row justify-content-center align-items-center text-center h-100">
            <div className="col-md-8">
              <FaTools className="me-3 text-danger mt-5" size={30} />
              <h1 className="mb-3 fw-bold display-4 display-md-3 display-lg-2">
                {t.heroContent.title}
                <div className="d-flex justify-content-center mt-2">
                  <div
                    style={{
                      width: '40px',
                      height: '3px',
                      backgroundColor: '#c8102e',
                    }}
                  ></div>
                  <div
                    style={{
                      width: '5px',
                      height: '3px',
                      backgroundColor: '#c8102e',
                      margin: '0 4px',
                    }}
                  ></div>
                  <div
                    style={{
                      width: '40px',
                      height: '3px',
                      backgroundColor: '#c8102e',
                    }}
                  ></div>
                </div>
              </h1>
              <h3 className="mb-4" style={{ color: '#EF4444' }}>
                {t.heroContent.subtitle}
              </h3>
              <p className="mb-4" style={{ color: '#000' }}>
                {t.heroContent.description}
              </p>
              <button
                className="btn btn-primary mt-3 btn-hover mb-5"
                style={{
                  backgroundColor: '#B91C1C',
                  borderRadius: '50px',
                  color: 'white',
                  padding: '10px 30px',
                  border: '0',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
                onClick={() => navigate('/contact')}
              >
                {t.heroContent.buttonText}
                <FaArrowRight className="btn-arrow" />
              </button>
            </div>
          </div>
        </div>

        <style>{`
          .btn-hover:hover .btn-arrow {
            transform: translateX(3px);
          }
          .btn-hover:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
          }
        `}</style>
      </section>

      <ManpowerServices topDataa={t.topData} />
      <ServicesRent />
      <FaqSection />
    </>
  );
};

export default GeneralContracting;